import { ChevronRightIcon, Flex, Link } from '@iheartjane/reefer';

import styles from './navItem.module.css';

export const NavItem = ({ title, to }: { title: string; to: string }) => {
  return (
    <Link
      className={styles['link']}
      to={to}
      variant="minimal"
      typography="body-bold"
    >
      <Flex justifyContent="space-between">
        {title}
        <ChevronRightIcon />
      </Flex>
    </Link>
  );
};
